<template>
  <div class="container-main" v-if="!isLoading">
    <div class="d-flex justify-space-between">
      <div class="container-main-header-button">
        <v-btn depressed @click="back">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <span>Редактирование</span>
      </div>
      <div></div>
    </div>
    <div
      class="d-flex align-center main-container-info-box"
      style="margin: 0 24px 40px 12px"
    >
      <v-switch
        v-model="electionOptions.showElection"
        @change="saveOptions(true)"
        hide-details
        color="var(--app-green-1)"
      ></v-switch>
      <span>Отображать раздел</span>
    </div>

    <ImageCropper
      @imageDesktopBlob="
        (img) => {
          photo.image = img;
        }
      "
      @imageMobileBlob="
        (img) => {
          photo.imageMobile = img;
        }
      "
      @imageTabletBlob="
        (img) => {
          photo.imageTablet = img;
        }
      "
      :width="'100%'"
      :modelValue="newImage"
      :imgSrcProp="electionOptions.icon"
      :imgSrcMobileProp="electionOptions.iconMobile"
      :imgSrcTabletProp="electionOptions.iconTablet"
      :placeToDisplay="'Изображение на фоне раздела'"
      :format="'Иконка раздела'"
      hideTitle
    ></ImageCropper>

    <v-alert color="var(--app-red-1)" type="error" v-model="errImagesMain">
      Прикрепите изображение
    </v-alert>

    <div class="container-block-footer-buttons">
      <div>
        <v-btn
          @click="saveOptions"
          style="width: auto !important"
          class="button-accept"
        >
          Сохранить
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import ImageCropper from "@/components/inputs/ImageCropper.vue";
export default {
  components: {
    ImageCropper,
  },
  data: () => ({
    electionOptions: {},
    errImagesMain: false,
    newImage: null,

    isLoading: true,

    formData: new FormData(),

    photo: {
      image: null,
      imageMobile: null,
      imageTablet: null,
    },
  }),

  methods: {
    back() {
      this.$emit("goToDetail");
    },

    getElectionOptions() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            "/ksa-election-blocks/election-settings",
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.electionOptions = res.data;
          this.photo = {
            image: this.electionOptions.icon,
            imageMobile: this.electionOptions.iconMobile,
            imageTablet: this.electionOptions.iconTablet,
          };
          this.isLoading = false;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    async uploadImage(image) {
      const formData = new FormData();
      formData.append("file", image);
      formData.append("path", "ElectionSettings");

      const { data } = await this.$axios.post(
        this.$store.getters.apiAdminPanelV5 + "/upload",
        formData,
        {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            "secret-key": this.$store.state.secretKeyCookie,
          },
        }
      );

      return data;
    },
    async saveOptions(switchOnly = false) {
      if (!this.photo.image && !switchOnly) {
        this.errImagesMain = true;
        return;
      }

      const optionsBody = { ...this.electionOptions };
      delete optionsBody.id;

      const promises = [];
      if (typeof this.photo.image !== "string") {
        promises.push(
          this.uploadImage(this.photo.image).then(
            (url) => (optionsBody.icon = url)
          )
        );
      }
      if (typeof this.photo.imageMobile !== "string") {
        promises.push(
          this.uploadImage(this.photo.imageMobile).then(
            (url) => (optionsBody.iconMobile = url)
          )
        );
      }
      if (typeof this.photo.imageTablet !== "string") {
        promises.push(
          this.uploadImage(this.photo.imageTablet).then(
            (url) => (optionsBody.iconTablet = url)
          )
        );
      }

      await Promise.all(promises);

      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV5 +
            "/ksa-election-blocks/election-settings",
          optionsBody,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.$store.commit("errorSet", {
            key: true,
            type: "success",
            text: "Настройки сохранены",
          });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
  created() {
    this.getElectionOptions();
  },
};
</script>
<style lang="scss" scoped>
.container-main {
  box-sizing: border-box;

  padding: 40px !important;

  .container-main-header-button {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    span {
      font-size: 28px;
      font-weight: 400;
      margin-left: 16px;
    }
  }

  .container-block {
    width: 50%;
    margin-bottom: 20px;

    .container-block-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 16px;
    }

    .container-block-gallery-button {
      text-decoration: underline;
      color: #1064dd;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;
      padding-bottom: 20px;
    }

    .table-img {
      height: 38px;
      object-fit: contain;
    }
  }

  .container-block-footer-buttons {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin-top: 60px;
  }
}

.dialog-tablet-img {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  img {
    width: 658;
    height: 192;
  }
}
</style>
